import type { SurveyOption } from '@/components/survey/MemberSurvey';

export interface SurveyConfig {
  surveyId: string;
  question: string;
  options: SurveyOption[];
}

export const ACTIVE_SURVEY: SurveyConfig | null = {
  surveyId: '202603_feature_priority',
  question: 'What feature would you like to see us build next?',
  options: [
    { id: 'new_analyst', title: 'Add Leter Pinch', description: 'Add a new analyst to commentate on the stocks from the perspective of a Growth Investor in contrast of a Value Investor like Baron Wuffett.' },
    { id: 'portfolio_analytics', title: 'Add New Analytics Tools to Paper Portfolio', description: 'Add analysis tools to Paper Portfolio including Sharpe Ratio calculation, Beta calculation, Asset Allocation charts.' },
    { id: 'achievements_friends', title: 'Add Achievements and Friends List', description: 'Add new achievements and badges to showcase expertise of the game, and add new social elements like friends lists.' },
    { id: 'new_categories', title: 'Add New Categories Like Congress', description: 'Add New Category for guessing stocks that Politicians have bought.' },
  ],
};
